import { render, staticRenderFns } from "./GFActurialForm.vue?vue&type=template&id=197aaf92"
import script from "./GFActurialForm.vue?vue&type=script&lang=js"
export * from "./GFActurialForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports